export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-primary-500/5 via-accent-500/10 to-primary-500/5 rounded-2xl p-8 md:p-12 border border-primary-200/30">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-4">
              移动追剧
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5 max-w-md">
              手机随时随地追剧，支持iOS与安卓系统。流畅播放、断点续看、
              离线缓存，让精彩剧情伴您左右，通勤路上也能轻松追完一集。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-white rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-line"></i>
                iOS 版
              </a>
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent-500 hover:bg-accent-600 text-white rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-line"></i>
                安卓版
              </a>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative w-48 md:w-56 aspect-[9/16] rounded-2xl overflow-hidden border-4 border-white/60">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20Chinese%20drama%20streaming%20app%20interface%20with%20warm%20dark%20theme%2C%20drama%20poster%20thumbnails%20on%20screen%2C%20modern%20UI%20design%2C%20clean%20layout%2C%20soft%20ambient%20lighting%20on%20device%2C%20product%20photography%20style&width=450&height=800&seq=app-mock-2026&orientation=portrait"
                alt="51影视移动端追剧界面"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}